module.exports = __webpack_public_path__ + "static/media/before-you-start.b09b22f4.svg";